import React from "react";

import "./index.scss";

interface IProps {
    colour: string;
}

export default class DiamondDiv extends React.Component<IProps> {
    render() {
        return <div className="diamond-div" style={{
            backgroundColor: this.props.colour
        }} />;
    }    
}
